<template>
    <div>
        <DeclarationForm
            v-if="declaration && ['EDITION'].includes(declaration.status)"
            :declaration="declaration"
            :formId="declaration.form.id"
            :hide-header="header"
            :decId="decId"
            :cerfaNumber="declaration.form.cerfaNumber"
            @declarationSent="refresh()"
        />
        <DocumentDeclaration
            v-else-if="declaration && declaration.form"
            :declaration="declaration"
            :formId="declaration.form.id"
            @updateDeclarationStatus="refresh()"
        />
        <DeclarationManager
            v-else-if="declaration"
            :id="decId"
            :propsCerfaNumber="cerfaNumber"
            :propsStartDate="declaration.startDate"
            :propsEndDate="declaration.endDate"
            @updateDeclarationStatus="refresh()"
        />
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { State2Way } from "@/decorators";

import DeclarationForm from "./DeclarationForm.vue";
import DocumentDeclaration from "./DocumentDeclaration.vue";
import DeclarationManager from "./DeclarationManager.vue";

import DECLARATION from "@/graphql/declaration/Declaration.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { convertCerfaNumber } from "../../../../../backend/src/common/declaration/declarationServices";

@Component({
    components: {
        DeclarationForm,
        DocumentDeclaration,
        DeclarationManager,
    },
})
export class Declaration extends Vue {
    @Prop({ default: "" }) decId: string;

    get header() {
        if (
            this.declaration &&
            (["EDITION"].includes(this.declaration.status) || this.haveMtaeError)
        ) {
            return false;
        } else {
            return true;
        }
    }

    get haveMtaeError() {
        if (this.declaration?.mtaeData?.errors?.length) {
            return true;
        }
        return false;
    }

    @Apollo({
        query: DECLARATION,
        variables() {
            return {
                id: this.decId,
            };
        },
        skip() {
            return !this.decId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.declaration) {
                    this.declaration = data.declaration;
                    const accountingPeriod = this.$store.getters.getAccountingPeriodFromId(
                        this.declaration.accountingPeriod.id
                    );
                    this.accountingPeriod = accountingPeriod;
                    if (this.declaration.sheets.length) {
                        this.cerfaNumber = convertCerfaNumber(
                            this.declaration.sheets[0].form.cerfaNumber
                        );
                    }
                }
            }
        },
    })
    declaration: any = null;

    cerfaNumber: string = "";

    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    accountingPeriod!: any;

    refresh() {
        this.$apollo.queries.declaration.refetch();
    }
}

export default toNative(Declaration);
</script>
